import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'

import SubmitButton from '../../common/buttons/SubmitButton'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './DeletePairingsModal.module.scss'
import classNames from 'classnames'

const DeletePairingsModal = ({ showModal, closeModal, onSubmit }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles.deletePairingsModal}
      autoFocus
    >
      <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
        <div className='d-flex justify-content-center align-items-center'>
          <WarningIcon/>
        </div>
        <div className={styles.modalContent}>
          <span className={styles.title}>{t('events.modal.deletePairings.title')}</span>
          <p className='my-3'>
            <Trans i18nKey='events.modal.deletePairings.confirmation' components={{ br: <span className='d-block' /> }} />
          </p>
        </div>
        <div className='w-100 pull-bottom'>
          <SubmitButton
            onClick={onSubmit}
            buttonMessage={t('events.modal.deletePairings.deleteButton')}
            buttonColor='orange-button'
          />
          <SubmitButton
            onClick={closeModal}
            buttonMessage={t('events.modal.deletePairings.exitButton')}
            buttonColor='navy-button'
          />
        </div>
      </div>
    </Modal>
  )
}

DeletePairingsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DeletePairingsModal
